import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('../views/Chat.vue'),
    meta: { requiresAuth: false } // 非必须登录，可以游客身份使用
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    meta: { requiresAuth: true } // 需要登录
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/Settings.vue'), // 使用新创建的Settings组件
    meta: { requiresAuth: true } // 需要登录
  },
  {
    path: '/video-classify',
    name: 'VideoClassify',
    component: () => import('../views/video-classify/VideoClassifyPage.vue'),
    meta: { requiresAuth: false } // 非必须登录，可以游客身份使用
  },
  {
    path: '/video-edit',
    name: 'VideoEdit',
    component: () => import('../views/VideoEdit.vue'),
    meta: { requiresAuth: false } // 非必须登录，可以游客身份使用
  },
  {
    path: '/video-summary',
    name: 'VideoSummary',
    component: () => import('../views/video-summary/VideoSummaryPage.vue'),
    meta: { requiresAuth: false } // 非必须登录，可以游客身份使用
  },
  {
    path: '/video-player',
    name: 'VideoPlayer',
    component: () => import('../views/VideoPlayer.vue'),
    meta: { requiresAuth: false } // 非必须登录，可以游客身份使用
  },
  {
    path: '/video-generate',
    name: 'VideoGenerate',
    component: () => import('../views/VideoGenerate.vue'),
    meta: { requiresAuth: false } // 非必须登录，可以游客身份使用
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else {
    next()
  }
})

// 确保每次路由变化后，页面滚动到顶部
router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router 